import { ErrorMessage } from "@msys/ui";
import { Button } from "@mui/material";
import * as Sentry from "@sentry/react";
import { useTranslate } from "@tolgee/react";
import React from "react";

interface Props {
  children: React.ReactNode;
  /** Rendered in place of the failed subtree. Defaults to a contained error message. */
  fallback?: React.ReactElement;
}

export const ErrorBoundary = ({ children, fallback }: Props) => {
  const { t } = useTranslate(["Global"]);

  return (
    <Sentry.ErrorBoundary
      fallback={
        fallback ?? (
          <ErrorMessage
            message={t("Something went wrong. Please try again.", {
              ns: "Global",
            })}
            // Sentry's boundary keeps the fallback until it is remounted, and
            // the route-level one outlives client-side navigation — a reload is
            // the only way out for the user.
            button={
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => window.location.reload()}
              >
                {t("Retry", { ns: "Global" })}
              </Button>
            }
          />
        )
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
